<mat-action-list>
  <div
    class="loren-bottom-sheet w-100"
    [ngClass]="isHandset ? 'loren-bottom-sheet-mobile' : ''">
    @if (!isHandset) {
      <p class="loren-bottom-sheet-version text-muted">
        {{ "home.platform_version" | transloco }} 24.48-22
      </p>
    }
    <button
      mat-icon-button
      class="loren-bottom-sheet-icon"
      (click)="closeBottomSheet()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @for (item of bottomSheetData.items; track item) {
    <mat-list-item
      mat-list-item
      href="#"
      class="loren-bottom-sheet-item"
      (click)="handleClick(item, $event)">
      @if (!isHandset) {
        <mat-icon
          matListItemAvatar
          svgIcon="why"
        class="loren-bottom-sheet-icon"></mat-icon>
      }
      <span class="loren-bottom-sheet-question">{{
        item.title | transloco
      }}</span>
      <span class="loren-bottom-sheet-description">{{
        item.subTitle | transloco
      }}</span>
    </mat-list-item>
  }
</mat-action-list>
